import React, { Component } from 'react';
import clpurl from './contact-lens-url.js'; 
//import html from "./clp.html";

//var __html = require('./clp.html');
//var template = { __html: __html };

import * as AWS from  "@aws-sdk/client-connect-contact-lens";

const {CognitoIdentityClient} = require("@aws-sdk/client-cognito-identity");
const {fromCognitoIdentityPool} = require("@aws-sdk/credential-provider-cognito-identity");
const REGION = 'us-east-1'
const client = new AWS.ConnectContactLens({
 region: REGION,
 mode: 'no-cors',
 credentials: fromCognitoIdentityPool({
 client: new CognitoIdentityClient({region:REGION}),
 identityPoolId: 'us-east-1:a6b399b9-047e-4764-a691-086ad439e4ad',
 logins: {
 // Optional tokens, used for authenticated login.
 },
 })
});

var params = {"InstanceId": "587c2cd5-2a58-44e8-9688-ffe0d8e3de82",
  "ContactId": "416d05bf-a428-4c90-b813-ddf875093e69",
  "MaxResults": 50,
  "NextToken": "fdsfsadgdfsgdfgfdhfghfghfgjmbnmnm"}

class CLP extends Component {
  constructor(props) {
    super(props);
    this.containerDiv = React.createRef();
  }

async  componentDidMount() {
    
    // async/await.
try {
  
  console.log('Calling API')
  const data = await client.listRealtimeContactAnalysisSegments(params,{mode:'no-cors'});
  console.log('data:',data)
  // process data.
  
  // Promises.
client
  .listRealtimeContactAnalysisSegments(params)
  .then((data) => {
    // process data.
  })
  .catch((error) => {
    // error handling.
    console.log('Error:',error)
  });

// callbacks.
client.listRealtimeContactAnalysisSegments(params, (err, data) => {
  // proccess err and data.

  console.log('Error:',err)
});
} catch (error) {
  console.log('Error:',error)
}


    var iframe = document.createElement('iframe');
    iframe.src = clpurl;
    iframe.allow = "microphone; autoplay";
    iframe.style = "width: 100%; height: 100%;position:absolute; clip:rect(60px, 1500px, 700px, 40px);";
    iframe.title = 'Amazon Connect CLP';
    this.containerDiv.current.appendChild(iframe);
  }

  render() {
    return (
    <div 
        className="containerDiv"
        ref={this.containerDiv}
        style={{height: 700, width: 1800}}
      />
    //<div dangerouslySetInnerHTML={template} />
    );
  }
}

export {CLP}